/**
 * The API's action rules (TutorPortalAPI `ActionRules`), mirrored for display. The server decides what is
 * overdue — this is only the number shown on the Overdue filter's label and badge. The shown value comes
 * from the settings store (api/Settings/Public, via PublicSettingsService); this constant is the fallback
 * when that read fails.
 */
export const ACTION_OVERDUE_DAYS = 7;
